"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var ForwardcontractsIcon = function ForwardcontractsIcon(props) {
  return _react["default"].createElement("svg", {
    "aria-hidden": "true",
    "data-id": "icon-forward-contracts",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    width: props.width || "70px",
    height: props.height || "70px"
  }, _react["default"].createElement("g", null, _react["default"].createElement("g", null, _react["default"].createElement("circle", {
    fill: props.fill || "#71c4ff",
    cx: "80.5",
    cy: "15.5",
    r: "2.5"
  }), _react["default"].createElement("path", {
    fill: props.fill || "#71c4ff",
    d: "M48,96A48,48,0,1,1,75.57,8.72,2,2,0,1,1,73.27,12,44,44,0,1,0,84,22.73a2,2,0,1,1,3.27-2.3A48,48,0,0,1,48,96Z"
  }), _react["default"].createElement("circle", {
    fill: props.fill || "#71c4ff",
    cx: "72",
    cy: "46",
    r: "4"
  }), _react["default"].createElement("line", {
    fill: props.fill || "#71c4ff",
    x1: "68",
    y1: "46",
    x2: "28",
    y2: "46"
  }), _react["default"].createElement("path", {
    fill: props.fill || "#71c4ff",
    d: "M76.24,41.76h0a6,6,0,0,0-8.48,0A5.83,5.83,0,0,0,66.35,44H29.64a5.83,5.83,0,0,0-1.4-2.24h0a6,6,0,0,0-8.48,0,6,6,0,1,0,8.48,8.48A5.83,5.83,0,0,0,29.64,48H66.35a5.83,5.83,0,0,0,1.41,2.24,6,6,0,0,0,8.48-8.48ZM25.42,47.41a2,2,0,0,1-2.83,0,2,2,0,0,1,0-2.82A2,2,0,0,1,24,44a2,2,0,0,1,1.42,3.41Z"
  }))));
};

var _default = ForwardcontractsIcon;
exports["default"] = _default;